import { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { CloseOutlined, SaveOutlined } from '@ant-design/icons'
import { EditsHelpersProvider } from './EditsHelpersProvider'
import { SpreadSheetDataProvider } from './SpreadSheetDataProvider'
import { TableDataProvider } from './TableDataProvider'
import { SpreadSheetHelpersProvider } from './SpreadSheetHelpersProvider'
import { categorizeIdsByType, getIdsWithType } from 'Services/WeaverUtils'
import { Button, Spin, Tabs, notification } from 'antd'
import { useHotKeys } from 'Hooks'
import { X, Add, Plus } from 'react-feather'
import SpreadSheetContainer from './SpreadSheetContainer'
import NewTabButton from './NewTabButton'
import ShortcutManager from 'Services/ShortcutManager'
import Circle from './Circle'
import { setTableConfig } from 'Actions/explore'
import './index.scss'

{ TabPane } = Tabs

MAXIMUM_COLUMNS = 31

SpreadSheetViewWrapper = ({ tableProps, onRemoveNodes, setTableConfig, props... }) ->

  [loading, setLoading] = useState(true)
  [typesMap, setTypesMap] = useState(undefined)
  [activeType, setActiveType] = useState(undefined)

  useEffect( ->
    ( ->
      setLoading(true)
      { node, type, name } = await categorizeIdsByType(tableProps.data.ids)
      uniqueTypes = _.uniq(type.map((t) -> t?.id() or 'Untyped'))
      tabs        = uniqueTypes.slice(0, MAXIMUM_COLUMNS - 1)

      showTabsExceededNotification() if uniqueTypes.length > MAXIMUM_COLUMNS
      newTypesMap = type.reduce((acc, type, i) ->
        typeId = type?.id() or 'Untyped'
        if typeId in tabs
          acc[typeId] ?= {
            label: name[i]?.value or typeId
            nodes: []
          }
          acc[typeId].nodes.push(node[i].id())
        acc
      , {})
      setTypesMap(newTypesMap)
      setActiveType(
        _.map(newTypesMap, (val, key) -> { val, key })
        .sort((a, b) -> a.val.nodes.length < b.val.nodes.length && 1 || -1)[0]?.key
      )
      setLoading(false)
    )()
    undefined
  , [tableProps])

  useEffect( ->
    if typesMap and not typesMap[activeType]
      if newKey = _.keys(typesMap)[0]
        setActiveType(_.map(typesMap, (val, type) ->
          { val, type }
        ).sort((a, b) -> a.val.nodes.length < b.val.nodes.length && 1 || -1)[0].type)
      else
        setTableConfig(undefined)
    undefined
  , [typesMap])

  showTabsExceededNotification = ->
    notification.info({
      message: "Woah. That's a lot of types."
      description:
        "If you cannot find the tab you are looking for please modify your query.
        Alternatively, you can open a new tab where you can find a list of types to choose from."
      duration: 5
    })

  closeAllTabs = ->
    setTypesMap(
      _.chain(typesMap)
      .pickBy((val) -> val.isDirty)
      .mapValues((obj) ->
        { obj..., isClosing: true }
      ).value()
    )

  useHotKeys([{
    sequence: 'esc'
    fn: closeAllTabs
    temporary: true
    watchers: [typesMap]
  }])

  if loading
    <Spin style={{ marginTop: '45vh' }} />
  else
    <>
      <Tabs
        activeKey={activeType}
        type="editable-card"
        onChange={setActiveType}
        style={{ width: props.width }}
        tabBarStyle={{ margin: 0 }}
        className="spreadsheet-view-tabs-container"
        onEdit={(key, action) ->
          if action is 'remove'
            setTypesMap({
              typesMap...,
              [key]: { typesMap[key]..., isClosing: true }
            })
        }
        addIcon={
          <NewTabButton
            onAdd={(key, { label, value }) ->
              setTypesMap({
                typesMap...,
                [value]: { key: value, label, nodes: await getIdsWithType(value) }
              })
              setActiveType(key)
            }
            activeTypes={_.keys(typesMap)}
          />
        }
      >
        {_.map(typesMap, (val, type) ->
          { val..., key: type }
        ).sort((a, b) -> a.nodes.length < b.nodes.length && 1 || -1)
        .map(({ key, label, nodes, isClosing, isDirty }) ->
          <TabPane
            tab={<><Circle color={key} />{ _.startCase(label) }</>}
            key={key}
            forceRender={isClosing}
            closeIcon={if isDirty then <SaveOutlined /> else <CloseOutlined />}
          >
            <SpreadSheetDataProvider>
              <TableDataProvider>
                <SpreadSheetHelpersProvider
                  tableProps={tableProps}
                  ids={nodes}
                  title={key}
                  isClosing={isClosing}
                  width={props.width}
                >
                  <EditsHelpersProvider onRemoveNodes={onRemoveNodes} tableProps={tableProps} subject={key}>
                    <SpreadSheetContainer
                      { props... }
                      tableProps={tableProps}
                      typesMap={typesMap}
                      type={key}
                      isClosing={isClosing}
                      setIsDirty={(isDirty) -> setTypesMap({ typesMap..., [key]: { typesMap[key]..., isDirty }})}
                      closeTab={(key) -> setTypesMap(_.omit(typesMap, key))}
                      tabLabel={label}
                    />
                  </EditsHelpersProvider>
                </SpreadSheetHelpersProvider>
              </TableDataProvider>
            </SpreadSheetDataProvider>
          </TabPane>
        )}
      </Tabs>
      <Button
        icon={<X style={{ width: 18, height: 18, color: '#aaa' }} />}
        type="link"
        size="large"
        style={{ top: 21, right: 10, position: 'fixed', padding: 10 }}
        onClick={closeAllTabs}
        data-testid="close-spreadsheet-btn"
      />
    </>

export default connect(
  null,
  { setTableConfig }
)(SpreadSheetViewWrapper)
